import {
  VITE_APP_BASE_URL,
  VITE_SUPER_APP_ANDROID_STORE_URL,
  VITE_SUPER_APP_IOS_STORE_URL,
} from '@/constants/configs';
import { ROUTE } from '@/constants/routes';

import { getPlatform } from './browser';

export function getSuperAppDeepLinkUrl(appBaseUrl = VITE_APP_BASE_URL): string {
  if (!appBaseUrl) {
    return ROUTE.OPEN_REPUBLIC_SUPER_APP;
  }

  return new URL(
    ROUTE.OPEN_REPUBLIC_SUPER_APP.replace(/^\//, ''),
    appBaseUrl.endsWith('/') ? appBaseUrl : `${appBaseUrl}/`,
  ).toString();
}

export function openRepublicSuperApp(): void {
  window.location.assign(getSuperAppDeepLinkUrl());
}

export function getSuperAppStoreUrl(
  iosStoreUrl = VITE_SUPER_APP_IOS_STORE_URL,
  androidStoreUrl = VITE_SUPER_APP_ANDROID_STORE_URL,
): string | undefined {
  const { isAndroid, isIOS, isIPadOS } = getPlatform();

  if (isIOS || isIPadOS) {
    return iosStoreUrl;
  }

  if (isAndroid) {
    return androidStoreUrl;
  }
}

export function redirectToSuperAppStore(): void {
  const storeUrl = getSuperAppStoreUrl();

  if (storeUrl) {
    window.location.replace(storeUrl);
  }
}
